/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Source_FileInputs */

const en_ui_data_source_file = /** @type {(inputs: Ui_Data_Source_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File upload`)
};

const de_ui_data_source_file = /** @type {(inputs: Ui_Data_Source_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei-Upload`)
};

/**
* | output |
* | --- |
* | "File upload" |
*
* @param {Ui_Data_Source_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_source_file = /** @type {((inputs?: Ui_Data_Source_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Source_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_source_file(inputs)
	return de_ui_data_source_file(inputs)
});